import { createPart, themeMaterial } from "ag-grid-enterprise";

const myCustomStyles = createPart({
	css: `
        .ag-header-cell-label {
            justify-content: center !important;
            display: flex !important;
            align-items: center !important;
            text-align: center !important;
            padding:0px !important;
    		font-size: 12px;

        }
        
        .ag-checkbox-input-wrapper {
            margin-left: 6.5px !important;

        }
        .ag-checkbox-input-wrapper.ag-checked {
            background-color: #00008B !important;
            border-color: #00008B !important;
        }

        .ag-header-icon{
            display: none !important;
        }

        .ag-cell {
            white-space: normal !important;
            word-wrap: break-word !important;
            line-height: 1.4 !important;
            text-align: center !important;
            border: none;
            padding:0px !important;
            display: flex;
            align-items: center;
            justify-content: center;
        }

        .ag-header-cell {
            white-space: normal !important;
            word-wrap: break-word !important;
        }

        .ag-row {
            border-bottom: 1px solid #e0e0e0;
        }

        .ag-cell-wrapper {
            height: auto !important;
            min-height: 32px !important;
        }

        .ag-menu {
            padding: 4px !important;
            background: #ffffff !important;
            border: 1px solid #e0e0e0 !important;
            border-radius: 8px !important;
            box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15) !important;
            min-width: 180px !important;
        }

        .ag-menu-list {
            padding: 4px !important;
        }

        .ag-menu-option {
            padding: 6px 10px !important;
            border-radius: 2px !important;
            margin: 2px 0 !important;
            font-size: 13px !important;
            color: #333333 !important;
            background: transparent !important;
            transition: all 0.2s ease !important;
        }

        .ag-menu-option:hover {
            background: #f5f5f5 !important;
            color: #00008B !important;
        }

        .ag-menu-option-disabled {
            color: #999999 !important;
            opacity: 0.6 !important;
        }

        .ag-menu-separator {
            border-top: 1px solid #e0e0e0 !important;
            margin: 4px 0 !important;
        }

        .ag-menu .ag-icon {
            color: #666666 !important;
            fill: #666666 !important;
        }
    `,
});

export const mesfTheme = themeMaterial
	.withParams({
		spacing: 1,
		headerFontSize: 10,
		rowHeight: 35,
		headerHeight: 32,
	})
	.withPart(myCustomStyles);

export const globalDefaultColDef = {
	wrapText: true,
	autoHeight: true,
	wrapHeaderText: true,
	resizable: true,
	cellStyle: {
		textAlign: "center",
		fontSize: "12px",
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		border: "none",
	},
};

export const mesfColors = {
	primary: {
		main: "#00008B",
		dark: "#00007B",
	},
	info: {
		main: "#3b82f6",
		dark: "#2563eb",
	},
	success: {
		main: "#10b981",
	},
	warning: {
		main: "#f59e0b",
	},
	error: {
		main: "#ef4444",
		dark: "#dc2626",
	},
	map: {
		assetHeader: "#0D47A1",
		rmOpenOrders: "#a8896b",
		parentChildHeader: "#546E7A",
		leafChildHeader: "#90A4AE",
	},
	background: {
		paper: "#ffffff",
		default: "#f8fafc",
	},
	text: {
		primary: "#1e293b",
		secondary: "#64748b",
	},
	grey: {
		50: "#f8fafc",
		100: "#f1f5f9",
		400: "#cbd5e1",
		divider: "#e2e8f0",
	},
	common: {
		white: "#ffffff",
		black: "#000000",
	},
	action: {
		hover: "#f1f5f9",
	},
	shadows: {
		2: "0 2px 8px rgba(0, 0, 0, 0.08)",
		4: "0 4px 16px rgba(0, 0, 0, 0.15), 0 0 0 1px rgba(0, 0, 0, 0.05)",
		8: "0 6px 24px rgba(0, 0, 0, 0.12), 0 0 0 1px rgba(0, 0, 0, 0.08)",
	},
} as const;

export const hexToRgba = (hex: string, opacity: number): string => {
	const r = Number.parseInt(hex.slice(1, 3), 16);
	const g = Number.parseInt(hex.slice(3, 5), 16);
	const b = Number.parseInt(hex.slice(5, 7), 16);
	return `rgba(${r}, ${g}, ${b}, ${opacity})`;
};
